import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import { Title, SubTitle, BoxActions, ButtoPayment, ColCentered, ButtoAdd, ButtoFinish, BoxInputs, BlackLine } from "./styles";
import FormInput from "components/core/FormInput";
import FormSelect from "components/core/FormSelect";
import Swal from "sweetalert2";
import { Element } from 'react-scroll';
import withReactContent from "sweetalert2-react-content";
import { ReactComponent as CreditCard } from "../../assets/img/credit-card.svg";
import { ReactComponent as BarCode } from "../../assets/img/barcode.svg";
import { ReactComponent as Player } from "../../assets/img/player_primary.svg";
import { cardCredit, validCard, validCodeCard } from "../../helpers/maskHelpers";
import { scrollTo } from "../../helpers/generalHelpers";
const AlertPaym = withReactContent(Swal);

export default function Payment({
  addBtn,
  initialPayment,
  values,
  touched,
  errors,
  isSubmitting,
  handleChange,
  setFieldValue,
  handleBlur,
  handleSubmit,
  event
}) {
  const [selectedPayment, setSelectPaymnet] = useState("");
  const buildPayments = value => {
    const priceEvent = value.split("$")[1].replace(/\./g,'').replace(/\,/g,'.');
    const values = parseFloat(priceEvent);
    const items = [];
    for (let i = 1; i <= 6; i++) {
      items.push((values / i).toFixed(2));
    }
    return items;
  };
  const showAlert = () => {
    AlertPaym.fire({
      title: `Valor ${event.price} - Deseja concluir a sua inscrição e gerar o boleto para pagamento ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não"
    }).then(result => {
      if (result.dismiss !== "cancel") {
        handleSubmit(values);
      }
    });
  };

  const registerPaymnetType = type => {
    setFieldValue("paymentType", type);
    setSelectPaymnet(type);
  };

  useEffect(() => {
    if (initialPayment) {
      setSelectPaymnet("")
    }
  }, [initialPayment])

  return (
    <div>
      <BlackLine />
      <Title>AGORA É SÓ ESCOLHER A MELHOR OPÇÃO DE PAGAMENTO!</Title>
      <SubTitle>
        Sua vaga estará garantida assim que nosso sistema identificar seu
        pagamento
      </SubTitle>
      <Row>
        {values.country === "32" && (
          <ColCentered sm="12" md="6">
            <ButtoPayment
              selected={selectedPayment === "boleto"}
              onClick={() => registerPaymnetType("boleto")}
              >
              <BarCode />
              <p style={{marginLeft: "10px"}}>BOLETO</p>
            </ButtoPayment>
          </ColCentered>
        )}
        <ColCentered sm="12" md={values.country === "32" ? "6" : "12"}>
          <ButtoPayment
            selected={selectedPayment === "creditCard"}
            onClick={() => {
              scrollTo("payment-card")
              registerPaymnetType("creditCard")
            }}
            >
            <CreditCard />
            <p style={{marginLeft: "10px"}}>
              CARTÃO DE CREDITO{" "}
            </p>
          </ButtoPayment>
        </ColCentered>
      </Row>
      <Element name="payment-card">
        {selectedPayment === "creditCard" && (
          <>
          <BlackLine />
          <BoxInputs>
            <FormInput
              type="text"
              id="creditCardName"
              name="creditCardName"
              value={values.creditCardName || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isError={errors.creditCardName && touched.creditCardName}
              error={errors.creditCardName}
              >
              Titular:
            </FormInput>
            <FormInput
              type="text"
              id="cardNumber"
              name="cardNumber"
              value={cardCredit(values.cardNumber) || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isError={errors.cardNumber && touched.cardNumber}
              error={errors.cardNumber}
              >
              Número do Cartão:
            </FormInput>
            <FormInput
              type="text"
              id="valid"
              name="valid"
              value={validCard(values.valid) || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isError={errors.valid && touched.valid}
              error={errors.valid}
              placeHolder="MM/AA"
              >
              Validade:
            </FormInput>
            <FormSelect
              label="Nº de parcelas:"
              id="numberPayment"
              name="numberPayment"
              value={values.numberPayment}
              onChange={handleChange}
              onBlur={handleBlur}
              isError={errors.numberPayment && touched.numberPayment}
              error={errors.numberPayment}
              >
              <option selected={values.numberPayment === ""}>Selecione...</option>
              {buildPayments(event.price).map((e, index) => {
                return (
                  <option key={index} value={index + 1}>{`${index + 1}X R$${e}`}</option>
                );
              })}
            </FormSelect>

            <FormInput
              type="text"
              id="cvv"
              name="cvv"
              value={validCodeCard(values.cvv) || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              isError={errors.cvv && touched.cvv}
              error={errors.cvv}
              placeHolder="CVV"
              >
              Cód. de segurança:
            </FormInput>
          </BoxInputs>
          <BlackLine />
          </>
        )}
      </Element>
      <BoxActions style={{ marginTop: "50px" }}>
        <ButtoFinish
          type="submit"
          onClick={
            selectedPayment ? selectedPayment === "creditCard" ? handleSubmit : () => showAlert() : () => {}
          }
          selected={selectedPayment}
        >
          <p>Concluir</p>
        </ButtoFinish>
      </BoxActions>
      {addBtn && <Row style={{marginRight: "0px", marginLeft: "0px"}}>
        <ColCentered sm="12">
          <ButtoAdd
            selected={selectedPayment}
            style={{ width: "100%", marginBottom: "30px" }}
            onClick={
              selectedPayment ? selectedPayment === "creditCard" ?  handleSubmit : () => showAlert() : () => {}
            }
            >
            <Player />
            <p style={{marginLeft: "10px"}}>ADICIONAR ATLETA</p>
          </ButtoAdd>
        </ColCentered>
      </Row>}
    </div>
  );
}
